import React from "react";
import { useSearchParams } from "react-router-dom";
import { Tabs } from "../components/ui";
import CharacterWizard from "../components/create/CharacterWizard";
import UniverseForm from "../components/create/UniverseForm";
import { useI18n } from "../services/i18n";
import "../styles/content.css";

/** /create — ตัวละคร (?edit=<id> แก้ไข/ต่อร่าง) หรือจักรวาล (?type=universe) */
export default function Create() {
  const [params, setParams] = useSearchParams();
  const { t } = useI18n();
  const type = params.get("type") === "universe" ? "universe" : "character";
  const edit = params.get("edit") || "";
  return (
    <div style={{ maxWidth: 1000, margin: "0 auto" }}>
      <div className="page-head"><div><h1>{edit ? "แก้ไข" : "สร้าง"}{type === "universe" ? t("จักรวาล") : t("ตัวละคร")}</h1><p>กรอกทีละขั้น บันทึกร่างไว้กลับมาทำต่อได้ · ไม่รองรับเนื้อหา 18+</p></div></div>
      {!edit ? <div className="mb-16"><Tabs tabs={[{ value: "character", label: t("สร้างตัวละคร") }, { value: "universe", label: t("สร้างจักรวาล") }]} value={type} onChange={(v) => setParams(v === "universe" ? { type: "universe" } : {}, { replace: true })} /></div> : null}
      {type === "universe" ? <UniverseForm key={`u${edit}`} editId={edit} /> : <CharacterWizard key={`c${edit}`} editId={edit} />}
    </div>
  );
}
